export default __webpack_public_path__ + "static/media/portalNode.17dff0fe.svg";